import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import BuilderFooter from './builder/BuilderFooter';
import LoggedInFooter from './LoggedInFooter';
import StaticFooter from './StaticFooter';

const Footer: React.FC = () => {
  const { user } = useAuth();
  const location = useLocation();
  const hideFooter = location.pathname === '/verify-email' || location.pathname === '/email-action';

  if (hideFooter) return null;

  if (user) {
    return <LoggedInFooter />;
  }

  return <BuilderFooter urlPath="/investor-footer" model="page" fallback={<StaticFooter />} />;
};

export default Footer;
